import React from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

const NotFoundPages = ({ errorIcon, errorMsg, errorTitle }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#ffffff',
        borderRadius: '16px',
        flexDirection: 'column',
        width: '100%',
        p: 2,
      }}>
      {errorIcon && (
        <Box>
          <img src={errorIcon} alt="error-info" />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '16px',
          maxWidth: '400px',
          marginTop: '20px',
        }}>
        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
          {errorTitle}
        </Typography>
        {errorMsg && (
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'center',
            }}>
            {errorMsg}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default NotFoundPages;
